import * as React from "react"

import { cn } from "./cn"
import { FIELD } from "./input"

/*
  A native <select> in the field surface. Native on purpose: it is keyboard- and
  screen-reader-correct for free, and every use so far is a short closed list.
*/
const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, ...props }, ref) => (
  <select
    ref={ref}
    data-slot="select"
    className={cn(FIELD, "h-12 appearance-auto", className)}
    {...props}
  />
))
Select.displayName = "Select"

export { Select }
